module.exports = __webpack_public_path__ + "static/media/mysql.32467178.svg";